import { FC } from 'react';
import { Center, Controls, Footer, Header, Layout, Left, Main, MainLayout, Right } from '../Components/Layout';
import styled from 'styled-components';
// @ts-ignore
import Logo from 'url:../Assets/logo.png';
// @ts-ignore
import LogoDarkBlue from 'url:../Assets/logo-dark-blue.png';

const MobileCompatibleMainLayout = styled(MainLayout).attrs((p) => ({
  ...p,
  className: 'mobile-compatible-main-layout',
}))`
  &.mobile-compatible-main-layout {
    @media screen and (max-width: 768px) {
      grid-template-columns: 1fr 3fr 1fr;
    }
  }
`;
const LogoImg = styled.div.attrs({
  className: 'logo-img',
})`
  &.logo-img {
    background: url('${Logo}') no-repeat center;
    background-size: cover;
    aspect-ratio: 1.23456790123;
    width: 10em;

    @media (prefers-color-scheme: light) {
      background: url('${LogoDarkBlue}') no-repeat center;
    }
  }
`;
const LoginCenter = styled(Center)`
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 3em;
`;

export type LoginProps = {
  onSignIn: () => void;
  goToDocumentAcceptance: () => void;
};

export const Login: FC<LoginProps> = ({ onSignIn, goToDocumentAcceptance }) => (
  <Layout>
    <Header />
    <Main>
      <MobileCompatibleMainLayout>
        <Left />
        <LoginCenter>
          <LogoImg />
          <Controls>
            <button onClick={onSignIn}>Sign In</button>
            <button onClick={goToDocumentAcceptance}>Sign Up</button>
          </Controls>
        </LoginCenter>
        <Right />
      </MobileCompatibleMainLayout>
    </Main>
    <Footer />
  </Layout>
);
